import axios from 'axios';
import { API_BASE_URL } from '../constants/config';

const API = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// --- REQUEST INTERCEPTOR ---
// Har request ke sath token check karega aur header mein lagayega
API.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error("Request Error:", error);
        return Promise.reject(error);
    }
);

// --- RESPONSE INTERCEPTOR ---
// Server se aane wale jawab ko check karega (Khaas tor par Auth errors)
API.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error;

        if (response) {
            // 401: Unauthorized (Token galat hai ya session out ho gaya)
            // 403: Forbidden (Token purana ho gaya)
            if ((response.status === 401 || response.status === 403) && 
                !window.location.pathname.includes('/login')) {
                
                console.warn("Session expired or unauthorized. Redirecting to login...");
                localStorage.clear(); // Sara data saaf karo (token, user info)
                window.location.href = '/login';
            }
        } else {
            // Agar server hi down ho ya internet ka masla ho
            console.error("Network Error: Server is not responding.");
        }

        return Promise.reject(error);
    }
);

export default API;